import { render, staticRenderFns } from "./ReInputSNILS.vue?vue&type=template&id=6c9fd832&scoped=true"
import script from "./ReInputSNILS.vue?vue&type=script&lang=js"
export * from "./ReInputSNILS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9fd832",
  null
  
)

export default component.exports